import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { EnvironmentService } from '../environment.service';

declare let gtag:Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  IsServiceInitiated: boolean = false;
  environmentService = inject(EnvironmentService);
  trackingId: string = this.environmentService.getGATrackingId();
  constructor(private _router: Router) { 
    this._router.events.pipe(
      filter((e): e is NavigationEnd => {
        return e instanceof NavigationEnd;
      })
    ).subscribe((e: NavigationEnd) => {
      setTimeout(() => {        
        if (this.IsServiceInitiated) {
          gtag('config', this.trackingId, {
                page_title: document.title.replace(/\s*\(.*?\)\s*/g, ''), //want to remove the count from the title
                page_location: location.href,
                page_path: location.hash.substring(0, location.hash.lastIndexOf('#')).replace('#', '')
              });   
            
        }
      });
    });
  }

  init() {
      const gTagManagerScript = document.createElement('script');
      gTagManagerScript.async = true;
      gTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.trackingId}`;
      document.head.appendChild(gTagManagerScript);
      const gaScript = document.createElement('script');
      gaScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        
      `;
      document.head.appendChild(gaScript);
      this.IsServiceInitiated = true;
    }

    logEvent(event:any, category:any, label:any, value:any) {
    if (this.IsServiceInitiated) {
      gtag('event', event, {
        event_category: category,
        event_label: label,
        value: value,
        'send_to': this.trackingId
      });
    } 
  }
}
